module.exports = "<router-outlet>\n\n</router-outlet>\n\n<div class=\"ajaxload\" [hidden]=\"loaderStatus\">\n  <div class=\"loader\">\n  </div>\n</div>"